
//使用mockjs的模板生成随机数据
const data = {
    "code": 200,
    "data": {
        "xData": [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ],
        "yData": [
            0,
            0,
            0,
            0,
            0,
            0,
            6,
            6
        ]
    },
    "message": "success"
}
export default data;

